<template>
    <v-col>
        <v-card>
            <!--Leyenda Gráfica-->
            <v-layout class="mt-1">
                <v-flex xs12>
                    <line-chart :chart-data="tempGrafico"></line-chart>
                </v-flex>
            </v-layout>
        </v-card>
        
        <!-- Datos del histórico -->
        <v-card>
            <v-card-title>Todos los datos del ciclo </v-card-title>
            <!-- Datos del ciclo -->
            
            
            <v-data-table :headers="cabecera_tabla_ciclo" disable-sort hide-default-footer :items="array_ensayo">
                <template v-slot:[`item.fecha_inicio`]="{ item }">
                    {{fecha_formateada(item.fecha_inicio)}}
                    
                </template>
        
            </v-data-table>
            <v-divider></v-divider>
            <v-data-table dense itemKey="id" :headers="headers" :items="datosGrafico">
                <template v-slot:[`item.fecha`]="{ item }">
                    {{ fecha_formateada(item.fecha) }}
                </template>


                <template v-slot:[`item.temperatura`]="{ item }">
                    <span>
                        {{ new Intl.NumberFormat('es-ES', {
                        minimumFractionDigits: 0, maximumFractionDigits: 2, style:
                        'unit', unit: 'celsius'
                        }).format(item.temperatura)
                        }}
                    </span>
                </template>
            </v-data-table>
        </v-card>
    </v-col>
</template>
<script>
import LineChart from './LineChartSinLineas.vue'
import moment from 'moment-timezone';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
} from 'chart.js'
ChartJS.register(Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale)

export default {
    props: {
        datos: [],
        opciones:[],
        ciclo: {}
    },
    components: {
        LineChart
    },
    data() {
        return {
            cabecera_tabla_ciclo: [
                { text: "CICLO", align: "center", value: "id" },
                { text: "Horno", align: "center", value: "horno" },
                { text: "Inicio Ciclo", align: "center", value: "fecha_inicio" },
                { text: "Lote", align: "center", value: "lote" },
                { text: "Kilos", align: "center", value: "kilos" },
                { text: "Consigna", align: "center", value: "consigna" },
                { text: "Trabajador", align: "center", value: "operario" },
            ],
            headers: [
                { text: "Fecha", align: "center", value: "fecha" },
                { text: "Temperatura", align: "center", value: "temperatura" },
            ],
            datosGrafico: []
           
        }
    },
    computed: {
        //Información del ciclo
        array_ensayo() {
            let datosCiclo = this.ciclo
            Object.keys(datosCiclo).forEach(e => {
                if(!datosCiclo[`${e}`]){
                    datosCiclo[`${e}`]= 'NO RELLENADO'
                }
            })
            return [datosCiclo]
        },
        //Pintar los puntos en el gráfico    
        tempGrafico() {
            let nuevo = {
                labels:[],
                datasets: [
                    {
                        data: [],
                        segment: {
                            borderColor:"#FF9800"
                        },
                        pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
                    },
                ]
            }

            //************************************DATOS DE PRUEBA ***************/
            // this.numEnsayo = 10
            // this.lote = 99
            // this.trabajador = "JOSE LUIS MARTINEZ"
            // this.mensajes.temperaturas = [
            //     { fecha: '2022-06-10T11:19:41+00', dato: 20, fase: 1 },
            //     { fecha: '2022-06-10T11:19:42+00', dato: 20, fase: 2 },
            //     { fecha: '2022-06-10T11:21:42+00', dato: 30, fase: 2 },
            //     { fecha: '2022-06-10T11:22:42+00', dato: 44, fase: 2 },
            //     { fecha: '2022-06-10T11:23:42+00', dato: 50, fase: 2 },
            //     { fecha: '2022-06-10T11:24:42+00', dato: 56, fase: 2 },
            //     { fecha: '2022-06-10T11:25:42+00', dato: 48, fase: 2 },
            //     { fecha: '2022-06-10T11:26:42+00', dato: 60, fase: 3 },
            //     { fecha: '2022-06-10T11:27:42+00', dato: 80, fase: 3 },
            //     { fecha: '2022-06-10T11:28:42+00', dato: 78, fase: 3 },
            //     { fecha: '2022-06-10T11:29:42+00', dato: 90, fase: 3 }]
            //********************************************************************* */
            
            let datosTemperaturas= this.datos
            datosTemperaturas.forEach(element => {
                let fecha_actual = new Date(element.fecha.replace('T', ' '));
                let a = moment(fecha_actual).format('HH:mm:ss')
                nuevo.datasets[0].data.push({ 'x': a, 'y': element.temperatura })
                nuevo.labels.push(a)
            })
           
            this.datosGrafico = datosTemperaturas.reverse()
            nuevo.consigna = typeof this.ciclo.consigna === 'number'?this.ciclo.consigna:null

            return nuevo
        }
    },
    methods: {
        fecha_formateada(f) {
            return moment(f).format('YYYY-MM-DD HH:mm:ss')
        },
        getCurretDate() {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        getDayFromDate(date) {
            // return (new Date(date)).toISOString().substr(0, 10)
            return date.split(' ')[0];
        },
        getHourFromDate(date) {
            // return date.split('T')[1].substring(0, 8);
            return date.split(' ')[1];
        },
        choosePhaseColor: (ctx) => {
            if (ctx.p0.raw.fase == ctx.p1.raw.fase) {
                if ([2].includes(ctx.p1.raw.fase)) return '#FF9800'
                if ([4].includes(ctx.p1.raw.fase)) return '#99ff33'
                else return '#2196F3'
            } else {
                return '#FF9800'
            }
        },
        calcularTiempoSecado(item) {
            let result = []
            this.datos.map(item => {
                if(item.phase == '2'){
                    result.push(item)
                }
            })

            return this.segundosAminutos(result.length)
        },
        segundosAminutos(duration){   
            // Hours, minutes and seconds
            var hrs = ~~(duration / 3600);
            var mins = ~~((duration % 3600) / 60);
            var secs = ~~duration % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        }
    },
    created(){
        // this.datos.splice()
    },
}
</script>
<style>
.texto {
    text-align: center;
    background-color: rgb(230, 230, 230);
    font-size: 2em;
}

.icono {
    text-align: center;
    font-size: 2em;
}
</style>